import { ToastContainer, ToastContainerProps } from "react-toastify";

export const toastOptions: ToastContainerProps = {
  position: "bottom-center",
  autoClose: 2000,
  hideProgressBar: false,
  newestOnTop: false,
  closeOnClick: true,
  rtl: false,
  pauseOnFocusLoss: true,
  draggable: true,
  pauseOnHover: true,
  theme: "dark",
  toastClassName: "toast-high-z-index",
};

const StyledToastContainer = () => {
  return (
    <>
      <style>
        {`
          .toast-high-z-index {
            z-index: 99999 !important;
          }
          .Toastify__toast-container {
            z-index: 99999 !important;
          }
        `}
      </style>
      <ToastContainer {...toastOptions} />
    </>
  );
};

export default StyledToastContainer;
